// AUTO-GENERATED FILE - DO NOT EDIT
// This file was automatically generated by the XDK build tool.
// Any manual changes will be overwritten on the next generation.
/**
 * Models for connections operations
 */
import type * as Schemas from '../schemas.js';





/**
 * Response for deleteAll
 * 
 * @public
 */
export type DeleteAllResponse = Schemas.KillAllConnectionsResponse;